/* Progressive enhancement. No provider keys, trackers, or customer briefs leave this script. */
(() => {
  'use strict';
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const cookieDialog = document.getElementById('und-cookie-dialog');
  const cookieForm = document.getElementById('und-cookie-form');
  const cookieStatus = document.getElementById('und-cookie-status');
  let privacyAPI;
  let returnFocus;
  document.querySelectorAll('form.und-product-form,#und-contact-form,form.und-cart-layout').forEach(form => {
    form.addEventListener('submit', event => {
      if (event.submitter?.hasAttribute('formnovalidate')) return;
      if (!form.reportValidity()) { event.preventDefault(); return; }
      const acknowledgment = form.querySelector('.und-policy-ack input');
      if (!acknowledgment?.checked) return;
      let field = form.querySelector('[data-acknowledged-at]');
      if (!field) {
        field = document.createElement('input');
        field.type = 'hidden';
        field.name = form.id === 'und-contact-form' ? 'contact[Acknowledged at]' : 'attributes[Acknowledged at]';
        field.dataset.acknowledgedAt = '';
        form.append(field);
      }
      field.value = new Date().toISOString();
    });
  });

  function showCookies() {
    if (!cookieDialog) return;
    returnFocus = document.activeElement;
    const current = privacyAPI?.currentVisitorConsent();
    ['analytics', 'marketing', 'preferences'].forEach(purpose => {
      cookieForm.elements[purpose].checked = current?.[purpose] === 'yes';
    });
    cookieStatus.textContent = privacyAPI ? '' : 'Connecting to Shopify’s privacy controls…';
    cookieDialog.showModal();
  }
  function closeCookies() { cookieDialog?.close(); returnFocus?.focus(); }
  document.querySelectorAll('[data-open-privacy]').forEach(button => button.addEventListener('click', showCookies));
  document.querySelector('[data-cookie-close]')?.addEventListener('click', closeCookies);
  function saveConsent(essentialOnly) {
    if (!privacyAPI) { cookieStatus.textContent = 'Privacy controls are unavailable. Your choices have not been saved. Please try again or use Your privacy choices in the footer.'; return; }
    const choices = {};
    ['analytics', 'marketing', 'preferences'].forEach(purpose => { choices[purpose] = essentialOnly ? false : cookieForm.elements[purpose].checked; });
    const buttons = cookieForm.querySelectorAll('button');
    buttons.forEach(button => { button.disabled = true; });
    cookieStatus.textContent = 'Saving your choices…';
    let completed = false;
    const deadline = setTimeout(() => {
      if (completed) return;
      cookieStatus.textContent = 'Shopify has not confirmed your choices. Please try again.';
      buttons.forEach(button => { button.disabled = false; });
    }, 8000);
    try {
      privacyAPI.setTrackingConsent(choices, () => {
        completed = true; clearTimeout(deadline);
        buttons.forEach(button => { button.disabled = false; });
        const saved = privacyAPI.currentVisitorConsent();
        const matches = Object.entries(choices).every(([purpose, value]) => saved[purpose] === (value ? 'yes' : 'no'));
        if (!matches) { cookieStatus.textContent = 'Your choices were not confirmed. Please try again.'; return; }
        cookieStatus.textContent = 'Your privacy choices have been saved.';
        closeCookies();
      });
    } catch (_) { clearTimeout(deadline); buttons.forEach(button => { button.disabled = false; }); cookieStatus.textContent = 'Privacy controls are unavailable. Your choices have not been saved.'; }
  }
  cookieForm?.addEventListener('submit', event => { event.preventDefault(); saveConsent(false); });
  document.getElementById('und-essential-only')?.addEventListener('click', () => saveConsent(true));
  if (window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
      if (!error && window.Shopify.customerPrivacy) { privacyAPI = window.Shopify.customerPrivacy; cookieStatus.textContent = ''; }
      else cookieStatus.textContent = 'Privacy controls could not load. Your choices have not been saved.';
    });
  } else if (cookieStatus) cookieStatus.textContent = 'Privacy controls could not load. Your choices have not been saved.';

  document.querySelectorAll('.und-product-form').forEach(form => {
    const variant = form.querySelector('[name="id"]');
    const plans = form.querySelector('[name="selling_plan"]');
    if (!variant || !plans) return;
    function updatePlans() {
      Array.from(plans.options).forEach(option => {
        if (!option.value) return;
        const eligible = (option.dataset.variants || '').includes(`|${variant.value}|`);
        option.disabled = !eligible;
        option.hidden = !eligible;
      });
      if (!plans.selectedOptions[0] || plans.selectedOptions[0].disabled) {
        plans.value = Array.from(plans.options).find(option => !option.disabled)?.value || '';
      }
      const button = form.querySelector('button[type="submit"]');
      if (button) button.disabled = variant.selectedOptions[0]?.disabled || (plans.required && !plans.value);
    }
    variant.addEventListener('change', updatePlans);
    updatePlans();
  });

  const browser = document.querySelector('[data-service-browser]');
  if (browser) {
    const panels = Array.from(browser.querySelectorAll('[data-category-panel]'));
    const links = Array.from(browser.querySelectorAll('[data-category-link]'));
    function selectCategory() {
      const requested = location.hash.slice(1);
      if (!requested || requested === 'all') {
        panels.forEach(panel => { panel.hidden = false; });
        links.forEach(link => { if (link.dataset.categoryLink === 'all') link.setAttribute('aria-current', 'true'); else link.removeAttribute('aria-current'); });
        return;
      }
      const selected = panels.find(panel => panel.id === requested) || panels[0];
      if (!selected) return;
      panels.forEach(panel => { panel.hidden = panel !== selected; });
      links.forEach(link => { if (link.dataset.categoryLink === selected.id) link.setAttribute('aria-current', 'true'); else link.removeAttribute('aria-current'); });
    }
    selectCategory();
    window.addEventListener('hashchange', selectCategory);
  }

  document.querySelectorAll('[data-package-adviser]').forEach(adviser => {
    const output = adviser.querySelector('.und-adviser-response');
    let catalog;
    try { catalog = JSON.parse(adviser.querySelector('[data-adviser-catalog]').textContent); }
    catch (_) { output.textContent = 'Please browse the service catalog or contact our team for help.'; return; }
    adviser.querySelectorAll('[data-adviser-category]').forEach(button => button.addEventListener('click', () => {
      adviser.querySelectorAll('button').forEach(choice => choice.setAttribute('aria-pressed', String(choice === button)));
      const services = catalog[button.dataset.adviserCategory] || [];
      const list = document.createElement('ul');
      services.forEach(service => {
        if (typeof service.url !== 'string' || !service.url.startsWith('/products/')) return;
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = service.url;
        const title = document.createElement('strong'); title.textContent = service.title;
        const price = document.createElement('span'); price.textContent = `${service.varies ? 'From ' : ''}${service.price}${service.monthly ? ' / month · arranged with us' : ''}`;
        link.append(title, price); item.append(link); list.append(item);
      });
      output.replaceChildren(list);
      if (!list.childElementCount) output.textContent = 'Contact our team to discuss this service area.';
    }));
  });
  const serviceField = document.getElementById('intake-service');
  const requestedService = new URLSearchParams(location.search).get('service');
  if (serviceField && !serviceField.value && /^[a-z0-9-]{1,100}$/.test(requestedService || '')) serviceField.value = requestedService;

  let observer;
  if (!reducedMotion.matches && 'IntersectionObserver' in window) {
    try {
      const targets = Array.from(document.querySelectorAll('[data-reveal]'));
      targets.forEach(el => { if (el.getBoundingClientRect().top < innerHeight) el.classList.add('is-visible'); });
      observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
      }), { threshold: .08, rootMargin: '0px 0px -15px 0px' });
      targets.filter(el => !el.classList.contains('is-visible')).forEach(el => observer.observe(el));
      document.documentElement.classList.add('und-reveal-enabled');
    } catch (_) { document.documentElement.classList.remove('und-reveal-enabled'); }
  }
  const canvas = document.getElementById('und-starfield');
  const context = canvas?.getContext('2d');
  let frame = 0;
  let last = 0;
  let stars = [];
  let userPaused = false;
  let elapsed = 0;
  const motionButton = document.getElementById('und-motion-toggle');
  function resizeStars() {
    if (!canvas || !context) return;
    const ratio = Math.min(devicePixelRatio || 1, 1.5);
    canvas.width = innerWidth * ratio; canvas.height = innerHeight * ratio;
    context.setTransform(ratio, 0, 0, ratio, 0, 0);
    const count = innerWidth < 700 ? 24 : 55;
    stars = Array.from({ length: count }, () => ({ x: Math.random() * innerWidth, y: Math.random() * innerHeight * .8, size: Math.random() * .9 + .25, phase: Math.random() * Math.PI * 2 }));
  }
  function paint(time) {
    frame = 0;
    if (document.hidden || reducedMotion.matches || !context) return;
    if (time - last > 33) {
      elapsed += Math.min(time - last, 80);
      context.clearRect(0, 0, innerWidth, innerHeight);
      stars.forEach(star => {
        const opacity = .2 + .25 * (1 + Math.sin(elapsed / 2400 + star.phase));
        context.fillStyle = `rgba(190,224,255,${opacity})`;
        context.beginPath(); context.arc((star.x + elapsed * .006) % innerWidth, star.y, star.size, 0, Math.PI * 2); context.fill();
      });
      // Two restrained orbital light trails keep the scene visibly alive without heavy rendering.
      for (let i = 0; i < 2; i++) {
        const phase = elapsed / 5500 + i * Math.PI;
        const x = innerWidth * .66 + Math.cos(phase) * innerWidth * .19;
        const y = innerHeight * .4 + Math.sin(phase) * innerHeight * .19;
        const glow = context.createRadialGradient(x, y, 0, x, y, 12);
        glow.addColorStop(0, 'rgba(207,239,255,.8)'); glow.addColorStop(1, 'rgba(164,218,255,0)');
        context.fillStyle = glow; context.fillRect(x - 12, y - 12, 24, 24);
      }
      last = time;
    }
    frame = requestAnimationFrame(paint);
  }
  function motionState() {
    document.body.classList.toggle('und-motion-paused', userPaused || document.hidden || reducedMotion.matches);
    if (userPaused || document.hidden || reducedMotion.matches) { cancelAnimationFrame(frame); frame = 0; last = 0; }
    else if (!frame && context) frame = requestAnimationFrame(paint);
    if (reducedMotion.matches) { observer?.disconnect(); document.documentElement.classList.remove('und-reveal-enabled'); }
  }
  resizeStars(); motionState();
  let resizeFrame;
  window.addEventListener('resize', () => { cancelAnimationFrame(resizeFrame); resizeFrame = requestAnimationFrame(resizeStars); }, { passive: true });
  motionButton?.addEventListener('click', () => {
    userPaused = !userPaused;
    motionButton.setAttribute('aria-pressed', String(userPaused));
    const motionLabel = motionButton.querySelector('.und-motion-label');
    if (motionLabel) {
      motionLabel.textContent = userPaused ? 'Play background' : 'Pause background';
      motionButton.querySelector('svg path')?.setAttribute('d', userPaused ? 'M8 5l11 7-11 7Z' : 'M8 5v14M16 5v14');
    } else motionButton.textContent = userPaused ? 'Play background' : 'Pause background';
    motionButton.setAttribute('aria-label', userPaused ? 'Play moving background' : 'Pause moving background');
    motionState();
  });
  document.addEventListener('visibilitychange', motionState);
  reducedMotion.addEventListener('change', motionState);
})();
